import React, { useEffect } from "react";
import styles from "../styles/dailyreport.module.css";
import PatrolResult from "./dailyreport/patrolresult";
import PatrolDemerit from "./dailyreport/patroldemerit";
import Studytimebar from "./dailyreport/studytimebar";
import StudytimeChart from "./dailyreport/studytimechart";
import StudytimeRanking from "./dailyreport/studytimeranking";
import PatrolViolateList from "./dailyreport/patrolviolatelist";
import AttendanceDemerit from "./dailyreport/attendancedemerit";
import EnglishTest from "./dailyreport/englishtest";
import PhoneInspect from "./dailyreport/phoneinspect";
import { ReactComponent as MainSvg } from "../../src/svg/newdaillymain.svg";
import { whichAcademyIncludeLocation } from "./dailyreport/data/data";
import { useReportLinkAuth, ReportVerifyGate, ReportLinkInvalid, ReportLinkLoading } from "../control/reportlinkauth";

const DailyReport: React.FC<any> = () => {

    //토큰 인증 — valid가 되기 전에는 리포트 DOM을 일절 그리지 않는다.
    //구 파라미터(id/code/date/name/location) 링크는 legacy-verify(휴대폰 인증)로 빠진다.
    const auth = useReportLinkAuth("daily");

    //렌더에 필요한 값은 전부 서버 resolve 응답(meta)에서 도출 — URL 파라미터 불신
    //userId는 리포트 내 본인 행 표시용일 뿐, 데이터 조회 권한은 토큰(t)만 유효
    const name = auth.meta ? auth.meta.name : "";
    const userId: any = auth.meta ? auth.meta.userId : undefined;
    const where: any = auth.meta ? auth.meta.location : undefined;
    const academy = where ? whichAcademyIncludeLocation(where) : undefined;

    var targetDate: Date | undefined = undefined;

    if (auth.meta && auth.meta.dateString) {
        const dateArray = auth.meta.dateString.split("-");
        targetDate = new Date(+dateArray[0], +dateArray[1] - 1, +dateArray[2]);
    }

    function shareToKaKao() {

        if (!auth.token || !targetDate) {
            return;
        }

        const suburl = `dailyreport?t=${auth.token}`;

        const dateString = `${targetDate.getFullYear()}년 ${targetDate.getMonth() + 1}월 ${targetDate.getDate()}일`;

        window.Kakao.Share.sendCustom({
            templateId: 111199,
            templateArgs: {
                suburl,
                day: dateString,
                name
            },
            serverCallbackArgs: {
                t: auth.token
            }
        })
    }

    useEffect(() => {

        const link = document.createElement("link");
        link.href = "../styles/pretendard.css";
        link.type = "text/css";
        link.rel = "stylesheet";
        link.media = "screen,print";
        link.onload = () => {
            console.log("font loaded");
        }

        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        }

    }, [])


    if (auth.status === "loading") {
        return <ReportLinkLoading />;
    }

    if (auth.status === "legacy-verify") {
        return <ReportVerifyGate auth={auth} />;
    }

    if (auth.status !== "valid" || !targetDate || !where || !academy) {
        return <ReportLinkInvalid />;
    }

    return (
        <div className={styles.dailyreport}>
            <>
                <div className={styles.mainFirstBack}>
                    <div className={styles.mainShare}>
                        <div className={styles.mainShareBtn}
                            onClick={shareToKaKao}
                        >
                            공유하기
                        </div>
                    </div>
                    <div className={styles.mainTitle}>
                        {name}님의 수능선배<br />데일리 리포트
                    </div>
                    <div className={styles.mainDate}>
                        발행일자&nbsp;&nbsp;{targetDate && targetDate.getFullYear() + "년 " + (targetDate.getMonth() + 1) + "월 " + targetDate.getDate() + "일"}
                    </div>
                    <div className={styles.mainSvgDiv}>
                        <MainSvg className={styles.mainSvg} />
                    </div>
                </div>
                <PatrolResult targetDate={targetDate} token={auth.token} userId={userId} name={name} where={where} academy={academy} />
                <div className={styles.justGap}>
                </div>
                <PatrolDemerit targetDate={targetDate} token={auth.token} userId={userId} />
                <div className={styles.justGap}>
                </div>
                <Studytimebar targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <StudytimeChart targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <StudytimeRanking targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <PatrolViolateList targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <AttendanceDemerit targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <EnglishTest targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
                <div className={styles.justGap}>
                </div>
                <PhoneInspect targetDate={targetDate} token={auth.token} userId={userId} location={where} name={name} />
            </>
        </div>
    )
}

export default DailyReport;
